module.exports = __webpack_public_path__ + "img/gift-16.21c52460.jpg";